import FoodInfoCard from '@design-system/Cards/FoodInfoCard';
import { StandardContainer } from '@design-system/StandardContainer';
import { getBackgroundImageUrl } from '@utils/nutrition/getImageUrl';

interface AboutInfoProps {
  aboutFoodInfo: {
    about_this_food: string;
    macronutrients: { title: string; value: string }[];
    food_composition: string;
    how_to_consume: string;
  };
  'data-testid'?: string;
}

export const MyFoodsDetailsFooterPage = ({ 
  aboutFoodInfo, 
  'data-testid': testId 
}: AboutInfoProps) => {
  const {
    about_this_food,
    food_composition: foodComposition,
    how_to_consume: howToConsume,
    macronutrients,
  } = aboutFoodInfo || {};

  const foodCompositionList = foodComposition?.split(',');
  const howToConsumeList = howToConsume?.split('\n');

  return (
    <div
      data-testid={testId}
      className="relative bg-cover bg-center p-4"
      style={{
        backgroundImage: `url(${getBackgroundImageUrl('food_details_footer_background.png')})`,
      }}
    >
      <StandardContainer data-testid={`${testId}-container`}>
        <FoodInfoCard
          data-testid={`${testId}-infoCard`}
          description={about_this_food}
          tips={howToConsumeList}
          composition={foodCompositionList}
          macronutrients={macronutrients}
        />
      </StandardContainer>
    </div>
  );
};
